import { Code } from 'lucide-react';
import {  useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";


<link rel="stylesheet" type='text/css' href="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css" />
          

interface Icardservices {
    title: string,
    text_one: string,
    text_two: string,
    text_three:string,
    text_four: string
}


export const CardTech = ({title, text_one, text_two, text_three, text_four}:Icardservices) => {
    
     const CardCentralTech = useRef<HTMLDivElement | null>(null)
    

    useEffect(() => {

        const sr = ScrollReveal()

        if(CardCentralTech.current) {
            sr.reveal(CardCentralTech.current, {
                origin: 'bottom',
                duration: 1500,
                distance: '100px',
                easing: 'ease-in-out'
            })
        }



         //para não evitar conflito
      return () => sr.destroy();
    }, [])
    
    
    
    return(
        <div  className="flex p-2 mt-10">

      <article 
      ref={CardCentralTech}
      className='md:flex  md:justify-between'>
          <div className='flex flex-col md:w-[30vw] gap-y-8  w-[80vw]  md:h-[38vh] bg-black p-3  items-start rounded-md text-white'>             
              <p className='font-bold text-red-600 fontTitle'>{title}</p>

              <div className='flex flex-col items-start gap-y-4 fontText'>
                  <div className='flex justify-around gap-x-10'>
                      <Code className='text-red-600'/>
                      {text_one}
                  </div>

                  <div className='flex justify-around gap-x-10'>
                      <Code className='text-red-600' />
                      {text_two}
                  </div>

                  <div className='flex justify-around gap-x-10'>
                      <Code className='text-red-600' />
                      {text_three}
                  </div>

                  <div className='flex justify-around gap-x-10'>
                      <Code className='text-red-600' />
                      {text_four}
                  </div>
              </div>
          </div>
      </article>

      
    </div>
    )
}